import { getClientCustomFetch } from '../lib/getClientCustomFetch'
import { getUrlStringFromParamObject } from '../lib/api'

const getServiceableArea = async (data) => {
  const customFetch = await getClientCustomFetch()

  const response = await customFetch.get(
    getUrlStringFromParamObject('/serviceable-area', {
      ...data,
    }),
    {
      headers: {
        excludeAuth: true,
      },
    }
  )
  return response?.data
}

const postCheckoutData = async (data) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/checkout', data)
  return response
}

const makeAnOrder = async (data) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/order', data)
  return response?.data
}

const rescheduleOrder = async (props) => {
  const customFetch = await getClientCustomFetch()
  const { referenceNumber, data } = props
  const response = await customFetch.put(`/order/${referenceNumber}`, data)
  return response?.data
}

const generateVerificationCode = async (data) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.post('/generate-code', data)
  return response
}

const getAuthDetails = async (authToken) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.get('/me', {
    headers: { Authorization: `Bearer ${authToken}` },
  })
  return response
}

const getViewAllCoupons = async (authToken) => {
  const customFetch = await getClientCustomFetch()
  const response = await customFetch.get('/coupon', {
    headers: { Authorization: `Bearer ${authToken}` },
  })
  return response
}

export {
  getServiceableArea,
  postCheckoutData,
  makeAnOrder,
  generateVerificationCode,
  getAuthDetails,
  getViewAllCoupons,
  rescheduleOrder,
}
